import { MetaTagsProps, SubCategory } from "@/types";
import { content } from "./content";
import { images } from "./images";
import { OG_PATH } from "@/content";
import {
  createImageItems,
  createServicePoints,
} from "@/content/services/service-content-helpers";

const slug = "fire-alarm-systems-sydney";
const serviceId = 4;

export const createMetaTags = (
  parentMetaTags: MetaTagsProps,
): { metaTags: MetaTagsProps; slug: string } => {
  const metaTags: MetaTagsProps = {
    title: "Fire Alarm Systems Sydney | Ozy Wide Group",
    description:
      "Smoke and fire alarm system support for safer homes, commercial premises and managed properties.",
    keywords:
      "fire alarm systems Sydney, smoke alarms Sydney, fire detection, alarm servicing, fire safety systems",
    url: `${parentMetaTags.url.replace(/\/$/, "")}/${slug}/`,
    ogImage: `${OG_PATH}service-${slug}.jpg`,
    type: "website",
  };

  return { metaTags, slug };
};

export const category: Omit<SubCategory, "headCategory" | "slug" | "metaTags"> =
  {
    id: serviceId,
    title: "Fire Alarm Systems",
    description:
      "Smoke and fire alarm system support for safer homes, commercial premises and managed properties.",
    points: createServicePoints(
      "Detection coverage reviewed",
      "Alarms and alerts planned around the property",
      "Servicing needs discussed clearly",
    ),
    images: createImageItems(images, "Fire Alarm Systems Sydney"),
    content,
  };
